/**
 * Corner radius scale (Figma: Liquid Glass, node 89519-22559).
 *
 * Design-system wide, not per partner — a partner rebrands colour and type,
 * not the geometry. Exposed as `theme.radius.*`.
 */

export const RADIUS_XS = '4px';
export const RADIUS_SM = '8px';
export const RADIUS_MD = '16px';
export const RADIUS_LG = '24px';
export const RADIUS_XL = '32px';
/** Pill / fully rounded. */
export const RADIUS_FULL = '999px';

export type TRadius = {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
  full: string;
};

export const radius: TRadius = {
  xs: RADIUS_XS,
  sm: RADIUS_SM,
  md: RADIUS_MD,
  lg: RADIUS_LG,
  xl: RADIUS_XL,
  full: RADIUS_FULL
};
